import {
  doc,
  onSnapshot,
  FirestoreError,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../firebase";
import { EntityGet, EntityServerGet, OnSnapshotDocService } from "../../types";
import { File } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type FileOnSnapshotDocService<T> = (
  promptId: string,
  id: string,
  callback: (doc: T) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotDoc: FileOnSnapshotDocService<EntityGet<File>> = (
  promptId,
  id,
  callback,
  onError
) => {
  const docRef = doc(db, `/prompt/${promptId}/file/${id}`);
  return onSnapshot(
    docRef,
    (docSnap) => {
      if (docSnap.exists()) {
        callback(
          processTimestampFields(
            transformMetadata(
              {
                ...docSnap.data(),
                id: docSnap.id,
              } as EntityServerGet<File>,
              docSnap.metadata
            )
          ) as EntityGet<File>
        );
      }
    },
    onError
  );
};

export default onSnapshotDoc;
